import React from 'react';

function HighUsageIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_21_1929)">
        <path
          d="M12.5 5C12.8 5 13 5.1 13.2 5.3L18.7 10.8C19.1 11.2 19.1 11.8 18.7 12.2C18.3 12.6 17.7 12.6 17.3 12.2L12.5 7.4L7.7 12.2C7.3 12.6 6.7 12.6 6.3 12.2C5.9 11.8 5.9 11.2 6.3 10.8L11.8 5.3C12 5.1 12.2 5 12.5 5ZM11.8 11.8L6.3 17.3C5.9 17.7 5.9 18.3 6.3 18.7C6.7 19.1 7.3 19.1 7.7 18.7L12.5 13.9L17.3 18.7C17.7 19.1 18.3 19.1 18.7 18.7C19.1 18.3 19.1 17.7 18.7 17.3L13.2 11.8C13 11.6 12.8 11.5 12.5 11.5C12.2 11.5 12 11.6 11.8 11.8Z"
          fill="#EF4136"
        />
      </g>
      <defs>
        <clipPath id="clip0_21_1929">
          <rect
            width="13"
            height="14"
            fill="white"
            transform="translate(19 19) rotate(180)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}

export default HighUsageIcon;
